import React from 'react';
import './VideoToolDescription.css';
import handFive from 'images/hand-5.png';


const VideoToolDescription = () => {
  return (
    <div className="iq-about grey-bg iq-mtb-40 mt-5" id="about-us">

      {/* new version */}
      <div className="about-overlay lg:flex lg:justify-center gap-0 pt-2">
        <div className={`ml-auto md:col-span-1 flexWidth`}>
          <img className = "mx-auto" src={handFive} alt='' />
        </div>
        <div className=" px-2  flexWidth">
          <div className="combine h-full px-2 flex justify-center mb-3 sm:mt-auto sm:mb-auto">
            <div className='text-4xl text-white font-bold w-full'>InFocus Video Tool</div>
            <div className='text-2xl text-white pt-3 font-semibold w-full'>Powered By ENData</div>
            <div className='text-white pt-2 w-full'>
              <div className='pt-2'>InFocus is a secure online communication platform that connects companies with people from the comfort and safety of your office.</div>
              <div className='pt-2'>InFocus has a seamless two-step process for audio-visual connection to portable devices across the globe. </div>
              <div className='pt-2'>InFocus is a white-label product that can be branded with your company logo and colours putting you at the forefront of technology and customer centric service. </div>
            </div>
          </div>
          
        </div>
      </div> 

    </div>
  )
}

export default VideoToolDescription;